(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cembre-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.documentElement.classList.add('cembre-js');
    var forms = document.querySelectorAll('.cembre-plp__body');
    forms.forEach(function (form) {
      // Auto-submit when a filter checkbox or the sort select changes.
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (!t) return;
        if (t.matches('input[type="checkbox"]') || t.matches('select[name="sort_by"]')) {
          form.submit();
        }
      });
    });

    // ── Live predictive product search ──
    var SKELETON =
      '<ul class="cembre-search__skeleton" aria-hidden="true">' +
      Array.apply(null, { length: 4 }).map(function () {
        return '<li class="cembre-search__skeleton-row">' +
          '<span class="cembre-search__skeleton-thumb"></span>' +
          '<span class="cembre-search__skeleton-lines">' +
          '<span class="cembre-search__skeleton-line"></span>' +
          '<span class="cembre-search__skeleton-line cembre-search__skeleton-line--short"></span>' +
          '</span></li>';
      }).join('') +
      '</ul>';

    document.querySelectorAll('[data-cembre-search]').forEach(function (root) {
      var input = root.querySelector('[data-search-input]');
      var panel = root.querySelector('[data-search-panel]');
      var clearBtn = root.querySelector('[data-search-clear]');
      var baseUrl = root.getAttribute('data-predictive-url') || '/search/suggest';
      if (!input || !panel) return;

      var SECTION = 'cembre-collection-search';
      var debounceTimer = null;
      var controller = null;
      var lastQuery = '';
      var activeIndex = -1;

      function setExpanded(open) {
        input.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      function openPanel() {
        if (panel.hidden) { panel.hidden = false; setExpanded(true); }
      }

      function closePanel() {
        panel.hidden = true;
        setExpanded(false);
        clearActive();
      }

      function results() {
        return Array.prototype.slice.call(panel.querySelectorAll('.cembre-search__result'));
      }

      function clearActive() {
        results().forEach(function (li) { li.setAttribute('aria-selected', 'false'); });
        activeIndex = -1;
        input.setAttribute('aria-activedescendant', '');
      }

      function setActive(index) {
        var items = results();
        if (!items.length) return;
        if (index < 0) index = items.length - 1;
        if (index >= items.length) index = 0;
        items.forEach(function (li, i) {
          var on = i === index;
          li.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on) {
            li.scrollIntoView({ block: 'nearest' });
            input.setAttribute('aria-activedescendant', li.id || '');
          }
        });
        activeIndex = index;
      }

      function activeLink() {
        var items = results();
        if (activeIndex < 0 || !items[activeIndex]) return null;
        return items[activeIndex].querySelector('[data-search-result-link]');
      }

      function showSkeleton() {
        panel.innerHTML = SKELETON;
        openPanel();
      }

      function fetchResults(q) {
        if (controller) controller.abort();
        controller = new AbortController();
        showSkeleton();
        var url = baseUrl +
          '?q=' + encodeURIComponent(q) +
          '&section_id=' + SECTION +
          '&resources[type]=product' +
          '&resources[limit]=6';
        fetch(url, { signal: controller.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            // Section Rendering API may wrap output in <div id="shopify-section-…">;
            // pull out our self-contained results container.
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var content = doc.querySelector('[data-search-inner]');
            panel.innerHTML = content ? content.innerHTML : '';
            clearActive();
            if (panel.innerHTML.trim() !== '') openPanel(); else closePanel();
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            closePanel();
          });
      }

      input.addEventListener('input', function () {
        var q = input.value.trim();
        if (clearBtn) clearBtn.hidden = q === '';
        if (q === lastQuery) return;
        lastQuery = q;
        clearTimeout(debounceTimer);
        if (q.length < 2) { closePanel(); return; }
        debounceTimer = setTimeout(function () { fetchResults(q); }, 220);
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          if (panel.hidden || !results().length) return;
          e.preventDefault();
          setActive(activeIndex + 1);
        } else if (e.key === 'ArrowUp') {
          if (panel.hidden || !results().length) return;
          e.preventDefault();
          setActive(activeIndex - 1);
        } else if (e.key === 'Enter') {
          var link = activeLink();
          if (link) {
            e.preventDefault();
            window.location.href = link.getAttribute('href');
          }
          // Otherwise let the form submit to the full /search results page.
        } else if (e.key === 'Escape') {
          if (!panel.hidden) { e.preventDefault(); closePanel(); }
          else if (input.value !== '') {
            input.value = ''; lastQuery = '';
            if (clearBtn) clearBtn.hidden = true;
          }
        }
      });

      input.addEventListener('focus', function () {
        if (input.value.trim().length >= 2 && panel.innerHTML.trim() !== '') openPanel();
      });

      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          input.value = '';
          lastQuery = '';
          clearBtn.hidden = true;
          closePanel();
          input.focus();
        });
      }

      // Close on outside click / tap.
      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) closePanel();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cembre-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Word-stagger reveal: triggers on load (above-the-fold) instead of intersection,
    // because the hero is always at the top.
    var titles = document.querySelectorAll('.cembre-hero__title[data-cembre-stagger]');
    function play() {
      titles.forEach(function (t) {
        // Force layout, then mark as revealed for the transition to fire.
        // eslint-disable-next-line no-unused-expressions
        t.offsetHeight;
        t.classList.add('is-revealed');
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', play);
    } else {
      requestAnimationFrame(play);
    }

    // Mark hero media as revealed once the product image decodes,
    // so the entrance happens after the asset is actually ready.
    var medias = document.querySelectorAll('.cembre-hero__media');
    medias.forEach(function (media) {
      var img = media.querySelector('.cembre-hero__product');
      var leaves = media.querySelector('.cembre-hero__leaves');
      function mark() {
        media.setAttribute('data-cembre-revealed', '');
        if (leaves) leaves.setAttribute('data-cembre-revealed', '');
      }
      if (!img) { mark(); return; }
      if (img.complete && img.naturalWidth > 0) {
        requestAnimationFrame(mark);
      } else {
        img.addEventListener('load', mark, { once: true });
        img.addEventListener('error', mark, { once: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cembre-navbar"]) return;
  try {
    
(function () {
  var nav = document.querySelector('.cembre-nav');
  var btn = nav && nav.querySelector('.cembre-nav__hamburger');
  var drawer = nav && nav.querySelector('.cembre-nav__drawer');
  var overlay = nav && nav.querySelector('.cembre-nav__overlay');
  var closeBtn = nav && nav.querySelector('.cembre-nav__drawer-close');

  if (!nav || !btn || !drawer) return;

  function openDrawer() {
    nav.classList.add('cembre-nav--open');
    btn.setAttribute('aria-expanded', 'true');
    btn.setAttribute('aria-label', 'Cerrar menú');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    drawer.querySelectorAll('[tabindex="-1"]').forEach(function (el) {
      el.setAttribute('tabindex', '0');
    });
    setTimeout(function () {
      if (closeBtn) closeBtn.focus();
    }, 50);
  }

  function closeDrawer() {
    nav.classList.remove('cembre-nav--open');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'Abrir menú');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    drawer.querySelectorAll('a, button').forEach(function (el) {
      el.setAttribute('tabindex', '-1');
    });
    btn.focus();
  }

  btn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.classList.contains('cembre-nav--open')) {
      closeDrawer();
    }
  });

  /* Set --header-height for any sections that may use it */
  var bar = nav.querySelector('.cembre-nav__bar');
  if (bar) {
    document.body.style.setProperty('--header-height', bar.offsetHeight + 'px');
    document.body.style.setProperty('--header-group-height', bar.offsetHeight + 'px');
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
